/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./resources/UpdateCartDelivery.ts":
/*!*****************************************!*\
  !*** ./resources/UpdateCartDelivery.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CartDelivery)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
var CartDelivery = /*#__PURE__*/function (_HTMLElement) {
  function CartDelivery() {
    var _this;
    _classCallCheck(this, CartDelivery);
    _this = _callSuper(this, CartDelivery);
    _defineProperty(_this, "observer", void 0);
    _defineProperty(_this, "countdownTimer", void 0);
    _this.updateCartDeliveryText = _this.updateCartDeliveryText.bind(_this);
    _this.handleEvent = _this.handleEvent.bind(_this);
    _this.handleCartContentLoaded = _this.handleCartContentLoaded.bind(_this);
    _this.init = _this.init.bind(_this);
    _this.updateLiveTimeCountdown = _this.updateLiveTimeCountdown.bind(_this);
    _this.startCountdown = _this.startCountdown.bind(_this);
    return _this;
  }
  // eslint-disable-next-line class-methods-use-this
  _inherits(CartDelivery, _HTMLElement);
  return _createClass(CartDelivery, [{
    key: "getExpectedDeliveryDates",
    value: function getExpectedDeliveryDates() {
      var today = new Date();
      var dayOfWeek = today.getDay();
      var extraDaysMondayOne = window.extraDaysMondayOne || 0;
      var extraDaysMondayTwo = window.extraDaysMondayTwo || 0;
      var extraDaysTuesdayOne = window.extraDaysTuesdayOne || 0;
      var extraDaysTuesdayTwo = window.extraDaysTuesdayTwo || 0;
      var extraDaysWednesdayOne = window.extraDaysWednesdayOne || 0;
      var extraDaysWednesdayTwo = window.extraDaysWednesdayTwo || 0;
      var extraDaysThursdayOne = window.extraDaysThursdayOne || 0;
      var extraDaysThursdayTwo = window.extraDaysThursdayTwo || 0;
      var extraDaysFridayOne = window.extraDaysFridayOne || 0;
      var extraDaysFridayTwo = window.extraDaysFridayTwo || 0;
      var extraDaysSaturday = window.extraDaysSaturday || 0;
      var extraDaysSunday = window.extraDaysSunday || 0;
      var deliveryDate;
      switch (dayOfWeek) {
        case 1:
          // Monday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysMondayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysMondayTwo * 24 * 60 * 60 * 1000);
          break;
        case 2:
          // Tuesday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysTuesdayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysTuesdayTwo * 24 * 60 * 60 * 1000);
          break;
        case 3:
          // Wednesday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysWednesdayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysWednesdayTwo * 24 * 60 * 60 * 1000);
          break;
        case 4:
          // Thursday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysThursdayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysThursdayTwo * 24 * 60 * 60 * 1000);
          break;
        case 5:
          // Friday
          deliveryDate = today.getHours() < 15 ? new Date(today.getTime() + extraDaysFridayOne * 24 * 60 * 60 * 1000) : new Date(today.getTime() + extraDaysFridayTwo * 24 * 60 * 60 * 1000);
          break;
        case 6:
          // Saturday
          deliveryDate = new Date(today.getTime() + extraDaysSaturday * 24 * 60 * 60 * 1000);
          break;
        case 0:
          // Sunday
          deliveryDate = new Date(today.getTime() + extraDaysSunday * 24 * 60 * 60 * 1000);
          break;
        default:
          throw new Error("Invalid day of the week");
      }
      var storeLangSetting = window.storeLang || "da";
      var options = {
        day: "numeric",
        month: "long"
      };
      var deliveryStr = deliveryDate.toLocaleDateString(storeLangSetting, options);
      return deliveryStr;
    }
  }, {
    key: "updateCartDeliveryText",
    value: function updateCartDeliveryText() {
      var _this2 = this;
      var cartdeliveryTextElements = document.querySelectorAll(".cart-estimated-delivery-text");
      cartdeliveryTextElements.forEach(function (element) {
        element.innerText = "".concat(_this2.getExpectedDeliveryDates());
      });
    }
  }, {
    key: "startCountdown",
    value: function startCountdown() {
      // hide live time on weekends
      var day = new Date().getDay();
      // 0 = Sunday, 6 = Saturday
      if (day === 0 || day === 6) {
        var liveTimeContainer = document.querySelector(".liveTimeContainer");
        if (liveTimeContainer) liveTimeContainer.style.display = "none";
        return;
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.updateLiveTimeCountdown();
      this.countdownTimer = window.setInterval(this.updateLiveTimeCountdown, 1000);
    }
    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "updateLiveTimeCountdown",
    value: function updateLiveTimeCountdown() {
      var liveTimeElement = document.querySelector(".liveTime");
      var liveTimeContainer = document.querySelector(".liveTimeContainer");
      if (!liveTimeElement) return;
      var now = new Date();
      // customized to show countdown until 12:00 instead of 15:00 variables are threePm still used for the logic
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      var threePm = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0);
      // If it's before midnight or at/after 12:00 => hide the timer
      if (now < midnight || now >= threePm) {
        liveTimeContainer.style.display = "none";
        return;
      }
      liveTimeContainer.style.display = "block";
      var distance = threePm.getTime() - now.getTime();
      var hours = Math.floor(distance / (1000 * 60 * 60));
      var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(distance % (1000 * 60) / 1000);
      var hh = hours.toString().padStart(2, "0");
      var mm = minutes.toString().padStart(2, "0");
      var ss = seconds.toString().padStart(2, "0");
      liveTimeElement.innerText = "".concat(hh, ":").concat(mm, ":").concat(ss);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;
      this.observer = new MutationObserver(function () {
        var cartdeliveryTextElements = document.querySelectorAll(".cart-estimated-delivery-text");
        if (cartdeliveryTextElements.length > 0) {
          _this3.updateCartDeliveryText();
          _this3.observer.disconnect();
        }
      });
      this.init();
      // Start the countdown to 15:00 (it will hide itself if outside 00:00–15:00)
      this.startCountdown();
    }
  }, {
    key: "init",
    value: function init() {
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      /*
        If you want to handle certain Shopify (or custom) events, re-add them here.
        For example:
          document.addEventListener('line-item:change:start', this.handleEvent);
          document.addEventListener('line-item:change:end', this.handleEvent);
          document.addEventListener('cart:item-added', this.handleEvent);
          document.addEventListener('product:variant-change', this.handleEvent);
          document.addEventListener('DOMContentLoaded', this.handleEvent);
      */
      this.handleCartContentLoaded();
      this.interceptNetRequest();
    }
  }, {
    key: "interceptNetRequest",
    value: function interceptNetRequest() {
      var originalFetch = window.fetch.bind(window);
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      function _fetch() {
        _fetch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, options) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (typeof url === "string" && (url.includes("cart/add") || url.includes("cart/change"))) {
                  this.handleEvent();
                }
                return _context.a(2, originalFetch(url, options));
            }
          }, _callee, this);
        }));
        return _fetch.apply(this, arguments);
      }
      window.fetch = fetch.bind(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent() {
      var cartdeliveryTextElements = document.querySelectorAll(".cart-estimated-delivery-text");
      if (cartdeliveryTextElements.length > 0) {
        this.updateCartDeliveryText();
      } else {
        this.observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  }, {
    key: "handleCartContentLoaded",
    value: function handleCartContentLoaded() {
      var cartdeliveryTextElements = document.querySelectorAll(".cart-estimated-delivery-text");
      if (cartdeliveryTextElements.length > 0) {
        this.updateCartDeliveryText();
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      document.removeEventListener("DOMContentLoaded", this.handleCartContentLoaded);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/app.ts":
/*!**************************!*\
  !*** ./resources/app.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_DataLayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @components/DataLayer */ "./resources/scripts/components/DataLayer/DataLayer.ts");
/* harmony import */ var _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @components/CookieBanner/Cookiebanner */ "./resources/scripts/components/CookieBanner/Cookiebanner.ts");
/* harmony import */ var _utils_ThemeScripts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @utils/ThemeScripts */ "./resources/scripts/utils/ThemeScripts.ts");
/* harmony import */ var _utils_SpriiImageOptimizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/SpriiImageOptimizer */ "./resources/scripts/utils/SpriiImageOptimizer.ts");
/* harmony import */ var _components_Preorder_PreorderAddToCart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @components/Preorder/PreorderAddToCart */ "./resources/scripts/components/Preorder/PreorderAddToCart.ts");
/* harmony import */ var _UpdateCartDelivery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./UpdateCartDelivery */ "./resources/UpdateCartDelivery.ts");






// HACK: rewrite Sprii's oversized Firebase cover images through an image proxy.
// Start first so the DOM observer is live before the widget injects its images.
(0,_utils_SpriiImageOptimizer__WEBPACK_IMPORTED_MODULE_0__["default"])();
var scripts = new _utils_ThemeScripts__WEBPACK_IMPORTED_MODULE_1__.ThemeScripts();
scripts.load({
  id: "gtm",
  strategy: "on-default-consent-set",
  gtmConfig: {
    containerId: "GTM-TWZBPS9W",
    serverUrl: "https://cdn.shuplondon.com",
    scriptName: "ffmdgpseqra.js"
  }
});
var dataLayer = new _components_DataLayer__WEBPACK_IMPORTED_MODULE_2__.DataLayer();
// Initialise the dataLayer — registers listeners now, runs once CookieBanner
// fires `edition:consent-default-set`.
dataLayer.init();
// Splits pre-order add-to-carts across the app's batches (hooked from <product-form> in theme.js).
(0,_components_Preorder_PreorderAddToCart__WEBPACK_IMPORTED_MODULE_3__["default"])();
customElements.define("cart-delivery", _UpdateCartDelivery__WEBPACK_IMPORTED_MODULE_4__["default"]);
// Register cookie-banner last so its connectedCallback fires the consent events
// after DataLayer/ThemeScripts have registered their listeners.
customElements.define("cookie-banner", _components_CookieBanner_Cookiebanner__WEBPACK_IMPORTED_MODULE_5__["default"]);

/***/ }),

/***/ "./resources/scripts/components/CookieBanner/Cookiebanner.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/CookieBanner/Cookiebanner.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ CookieBanner)
/* harmony export */ });
/* harmony import */ var _utils_Logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @utils/Logger */ "./resources/scripts/utils/Logger.ts");
/* harmony import */ var _utils_Storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/Storage */ "./resources/scripts/utils/Storage.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }


var CONSENT_STORAGE_KEY = "cookieSelections";
var CONSENT_DENIED_DEFAULTS = {
  personalization: false,
  marketing: false,
  analytics: false
};
var CONSENT_KEYS = ["personalization", "marketing", "analytics"];
/**
 * Cookie consent banner web component.
 *
 * Handles Consent Mode v2 (gtag default + update), Shopify Customer Privacy API
 * integration, and a consent-category checkbox UI with synced consent/details tabs.
 *
 * @example
 * ```html
 * <cookie-banner data-force-show="true"></cookie-banner>
 * ```
 *
 * @fires {CustomEvent} edition:consent-default-set - After gtag consent defaults are applied.
 * @fires {CustomEvent} edition:consent-updated     - After the user accepts, selects, or rejects.
 *
 * @see {@link showBanner} to open the banner programmatically.
 */
var CookieBanner = /*#__PURE__*/function (_HTMLElement) {
  function CookieBanner() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _classCallCheck(this, CookieBanner);
    _this = _callSuper(this, CookieBanner, [].concat(args));
    _defineProperty(_this, "consentApiReady", false);
    /** Sets gtag consent defaults, fires `edition:consent-default-set`, and optionally loads GTM. */
    _defineProperty(_this, "setupConsent", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _window$gtag, _window, _window$gtag2, _window2, _window$gtag3, _window3;
      var stored, selections;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.ensureGtag();
            stored = _utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY);
            selections = stored !== null && stored !== void 0 ? stored : CONSENT_DENIED_DEFAULTS; // `wait_for_update` tells GTM to hold every consent-gated tag until a `consent update`
            // arrives. Only a banner click produces that update (see `applyConsent`), so sending it
            // for a returning visitor — whose stored answer is already baked into the defaults below
            // — stalls all tags for the full timeout waiting for an update that never comes.
            // Ask GTM to wait only when we genuinely don't know yet, i.e. the banner is about to show.
            (_window$gtag = (_window = window).gtag) === null || _window$gtag === void 0 || _window$gtag.call(_window, "consent", "default", _objectSpread({
              functionality_storage: "granted",
              analytics_storage: selections.analytics ? "granted" : "denied",
              personalization_storage: selections.personalization ? "granted" : "denied",
              ad_personalization: selections.personalization ? "granted" : "denied",
              ad_storage: selections.marketing ? "granted" : "denied",
              ad_user_data: selections.marketing ? "granted" : "denied"
            }, stored ? {} : {
              wait_for_update: 3000
            }));
            (_window$gtag2 = (_window2 = window).gtag) === null || _window$gtag2 === void 0 || _window$gtag2.call(_window2, "set", "ads_data_redaction", !selections.marketing);
            (_window$gtag3 = (_window3 = window).gtag) === null || _window$gtag3 === void 0 || _window$gtag3.call(_window3, "set", "url_passthrough", true);
            window.dispatchEvent(new CustomEvent("edition:consent-default-set"));
            _context.n = 1;
            return _this.loadShopifyConsentApi();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "addEventListeners", function () {
      var _this$querySelector, _this$querySelector2, _this$querySelector3, _this$querySelector4, _this$querySelector5, _document$getElementB;
      (_this$querySelector = _this.querySelector("#tab-consent")) === null || _this$querySelector === void 0 || _this$querySelector.addEventListener("click", function () {
        return _this.activateTab("consent");
      });
      (_this$querySelector2 = _this.querySelector("#tab-details")) === null || _this$querySelector2 === void 0 || _this$querySelector2.addEventListener("click", function () {
        return _this.activateTab("details");
      });
      (_this$querySelector3 = _this.querySelector(".allow-all-btn")) === null || _this$querySelector3 === void 0 || _this$querySelector3.addEventListener("click", _this.handleAllowAll);
      (_this$querySelector4 = _this.querySelector(".allow-selected-btn")) === null || _this$querySelector4 === void 0 || _this$querySelector4.addEventListener("click", _this.handleAllowSelected);
      (_this$querySelector5 = _this.querySelector('[data-action="reject"]')) === null || _this$querySelector5 === void 0 || _this$querySelector5.addEventListener("click", _this.handleRejectAll);
      (_document$getElementB = document.getElementById("manage-cookie-consent")) === null || _document$getElementB === void 0 || _document$getElementB.addEventListener("click", function (event) {
        event.preventDefault();
        _this.showBanner();
      });
    });
    _defineProperty(_this, "activateTab", function (tab) {
      ["consent", "details"].forEach(function (id) {
        var _this$querySelector6, _this$querySelector7, _this$querySelector8;
        (_this$querySelector6 = _this.querySelector("#tab-".concat(id))) === null || _this$querySelector6 === void 0 || _this$querySelector6.classList.toggle("active", id === tab);
        (_this$querySelector7 = _this.querySelector("#panel-".concat(id))) === null || _this$querySelector7 === void 0 || _this$querySelector7.classList.toggle("active", id === tab);
        (_this$querySelector8 = _this.querySelector("#panel-".concat(id))) === null || _this$querySelector8 === void 0 || _this$querySelector8.classList.toggle("tw:hidden!", id !== tab);
      });
    });
    /**
     * Returns true if the banner should be shown.
     * Prefers localStorage over the Shopify API — if the user has a stored selection we trust it
     * and skip the async API call entirely.
     */
    _defineProperty(_this, "shouldShowBanner", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _window$Shopify;
      var _yield$window$Shopify, preferences, analytics, marketing, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (!_utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, false);
          case 1:
            if (!(!_this.consentApiReady || !((_window$Shopify = window.Shopify) !== null && _window$Shopify !== void 0 && (_window$Shopify = _window$Shopify.customerPrivacy) !== null && _window$Shopify !== void 0 && _window$Shopify.currentVisitorConsent))) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2, true);
          case 2:
            _context2.p = 2;
            _context2.n = 3;
            return window.Shopify.customerPrivacy.currentVisitorConsent();
          case 3:
            _yield$window$Shopify = _context2.v;
            preferences = _yield$window$Shopify.preferences;
            analytics = _yield$window$Shopify.analytics;
            marketing = _yield$window$Shopify.marketing;
            return _context2.a(2, [preferences, analytics, marketing].every(function (v) {
              return (v !== null && v !== void 0 ? v : "") === "";
            }));
          case 4:
            _context2.p = 4;
            _t = _context2.v;
            return _context2.a(2, true);
        }
      }, _callee2, null, [[2, 4]]);
    })));
    _defineProperty(_this, "loadShopifyConsentApi", function () {
      var _window$Shopify2;
      if (!((_window$Shopify2 = window.Shopify) !== null && _window$Shopify2 !== void 0 && _window$Shopify2.loadFeatures)) {
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        try {
          window.Shopify.loadFeatures([{
            name: "consent-tracking-api",
            version: "0.1"
          }], function (error) {
            if (error) {
              _utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].error("Shopify consent-tracking-api failed to load", error);
              resolve();
              return;
            }
            _this.consentApiReady = true;
            resolve();
            document.addEventListener("visitorConsentCollected", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
              var _window$Shopify3, _window$Shopify3$curr, v, _t2;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.p = _context3.n) {
                  case 0:
                    _context3.p = 0;
                    _context3.n = 1;
                    return (_window$Shopify3 = window.Shopify) === null || _window$Shopify3 === void 0 || (_window$Shopify3 = _window$Shopify3.customerPrivacy) === null || _window$Shopify3 === void 0 || (_window$Shopify3$curr = _window$Shopify3.currentVisitorConsent) === null || _window$Shopify3$curr === void 0 ? void 0 : _window$Shopify3$curr.call(_window$Shopify3);
                  case 1:
                    v = _context3.v;
                    if (v) {
                      _context3.n = 2;
                      break;
                    }
                    return _context3.a(2);
                  case 2:
                    _this.setConsentGroup({
                      key: "personalization",
                      checked: v.preferences === "yes"
                    });
                    _this.setConsentGroup({
                      key: "marketing",
                      checked: v.marketing === "yes"
                    });
                    _this.setConsentGroup({
                      key: "analytics",
                      checked: v.analytics === "yes"
                    });
                    _this.saveSelections();
                    _context3.n = 4;
                    break;
                  case 3:
                    _context3.p = 3;
                    _t2 = _context3.v;
                    _utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].error("visitorConsentCollected handler error", _t2);
                  case 4:
                    return _context3.a(2);
                }
              }, _callee3, null, [[0, 3]]);
            })));
          });
        } catch (e) {
          _utils_Logger__WEBPACK_IMPORTED_MODULE_1__["default"].error("Shopify loadFeatures threw", e);
          resolve();
        }
      });
    });
    /** Updates gtag consent, persists to localStorage, and fires `edition:consent-updated`. */
    _defineProperty(_this, "applyConsent", function (_ref4) {
      var _window$gtag4, _window4, _window$gtag5, _window5, _window$Shopify4, _window$Shopify4$setT;
      var consent = _ref4.consent,
        hide = _ref4.hide;
      (_window$gtag4 = (_window4 = window).gtag) === null || _window$gtag4 === void 0 || _window$gtag4.call(_window4, "consent", "update", {
        functionality_storage: "granted",
        analytics_storage: consent.analytics === "yes" ? "granted" : "denied",
        personalization_storage: consent.preferences === "yes" ? "granted" : "denied",
        ad_personalization: consent.preferences === "yes" ? "granted" : "denied",
        ad_storage: consent.marketing === "yes" ? "granted" : "denied",
        ad_user_data: consent.marketing === "yes" ? "granted" : "denied"
      });
      (_window$gtag5 = (_window5 = window).gtag) === null || _window$gtag5 === void 0 || _window$gtag5.call(_window5, "set", "ads_data_redaction", consent.marketing !== "yes");
      _this.saveSelections();
      window.dispatchEvent(new CustomEvent("edition:consent-updated"));
      (_window$Shopify4 = window.Shopify) === null || _window$Shopify4 === void 0 || (_window$Shopify4 = _window$Shopify4.customerPrivacy) === null || _window$Shopify4 === void 0 || (_window$Shopify4$setT = _window$Shopify4.setTrackingConsent) === null || _window$Shopify4$setT === void 0 || _window$Shopify4$setT.call(_window$Shopify4, {
        analytics: consent.analytics === "yes",
        marketing: consent.marketing === "yes",
        preferences: consent.preferences === "yes"
      });
      if (hide) {
        _this.hideBanner();
      }
    });
    _defineProperty(_this, "handleAllowAll", function () {
      _this.querySelectorAll("input.ed-checkbox[data-consent]").forEach(function (cb) {
        if (!cb.disabled) {
          cb.checked = true;
        }
      });
      _this.applyConsent({
        consent: {
          preferences: "yes",
          marketing: "yes",
          analytics: "yes"
        },
        hide: true
      });
    });
    _defineProperty(_this, "handleAllowSelected", function () {
      var _this$getSelections = _this.getSelections(),
        personalization = _this$getSelections.personalization,
        marketing = _this$getSelections.marketing,
        analytics = _this$getSelections.analytics;
      _this.applyConsent({
        consent: {
          preferences: personalization ? "yes" : "no",
          marketing: marketing ? "yes" : "no",
          analytics: analytics ? "yes" : "no"
        },
        hide: true
      });
    });
    _defineProperty(_this, "handleRejectAll", function () {
      _this.applyConsent({
        consent: {
          preferences: "no",
          marketing: "no",
          analytics: "no"
        },
        hide: true
      });
    });
    /** Keeps the consent/details tab panels in sync — the same consent key can appear in both tabs. */
    _defineProperty(_this, "syncCheckboxGroups", function () {
      var checkboxes = Array.from(_this.querySelectorAll("input.ed-checkbox[data-consent]"));
      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener("change", function (_ref5) {
          var currentTarget = _ref5.currentTarget;
          var source = currentTarget;
          checkboxes.forEach(function (other) {
            if (other !== source && other.dataset.consent === source.dataset.consent && !other.disabled) {
              other.checked = source.checked;
            }
          });
        });
      });
      var grouped = checkboxes.reduce(function (acc, cb) {
        var _acc$key;
        var key = cb.dataset.consent;
        ((_acc$key = acc[key]) !== null && _acc$key !== void 0 ? _acc$key : acc[key] = []).push(cb);
        return acc;
      }, {});
      Object.values(grouped).forEach(function (_ref6) {
        var _ref7 = _toArray(_ref6),
          source = _ref7[0],
          rest = _arrayLikeToArray(_ref7).slice(1);
        rest.forEach(function (cb) {
          if (!cb.disabled) {
            cb.checked = source.checked;
          }
        });
      });
    });
    _defineProperty(_this, "setConsentGroup", function (_ref8) {
      var key = _ref8.key,
        checked = _ref8.checked;
      _this.querySelectorAll("input.ed-checkbox[data-consent=\"".concat(key, "\"]")).forEach(function (cb) {
        if (!cb.disabled) {
          cb.checked = checked;
        }
      });
    });
    _defineProperty(_this, "saveSelections", function () {
      _utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.set(CONSENT_STORAGE_KEY, _this.getSelections());
    });
    _defineProperty(_this, "getSelections", function () {
      return CONSENT_KEYS.reduce(function (acc, key) {
        var _this$querySelector9;
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, !!((_this$querySelector9 = _this.querySelector("input.ed-checkbox[data-consent=\"".concat(key, "\"]"))) !== null && _this$querySelector9 !== void 0 && _this$querySelector9.checked)));
      }, {
        personalization: false,
        marketing: false,
        analytics: false
      });
    });
    /**
     * Opens the banner. Applies any previously saved selections to the checkboxes first —
     * if nothing is stored, the HTML defaults remain as-is.
     * Can be triggered externally via `#manage-cookie-consent`.
     */
    _defineProperty(_this, "showBanner", function () {
      var saved = _utils_Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY);
      if (saved) {
        CONSENT_KEYS.forEach(function (key) {
          return _this.setConsentGroup({
            key: key,
            checked: saved[key]
          });
        });
      }
      _this.overlay.removeAttribute("hidden");
      _this.overlay.classList.remove("tw:hidden!");
    });
    _defineProperty(_this, "hideBanner", function () {
      _this.overlay.classList.add("tw:hidden!");
    });
    /** Creates a `window.gtag` shim that queues calls into `dataLayer` if the real gtag hasn't loaded yet. */
    _defineProperty(_this, "ensureGtag", function () {
      window.dataLayer = window.dataLayer || [];
      if (!window.gtag) {
        // function keyword is intentional — arrow functions have no `arguments` object,
        // but GTM's consent processing requires the IArguments shape, not a plain array.
        /* eslint-disable @typescript-eslint/no-explicit-any, prefer-rest-params */
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
        /* eslint-enable @typescript-eslint/no-explicit-any, prefer-rest-params */
      }
    });
    return _this;
  }
  _inherits(CookieBanner, _HTMLElement);
  return _createClass(CookieBanner, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.setupConsent();
            case 1:
              this.addEventListeners();
              this.activateTab("consent");
              this.syncCheckboxGroups();
              _t3 = this.dataset.forceShow === "true";
              if (_t3) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return this.shouldShowBanner();
            case 2:
              _t3 = _context4.v;
            case 3:
              if (!_t3) {
                _context4.n = 4;
                break;
              }
              this.showBanner();
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "overlay",
    get: function get() {
      var _this$querySelector0;
      return (_this$querySelector0 = this.querySelector("[data-cookie-overlay]")) !== null && _this$querySelector0 !== void 0 ? _this$querySelector0 : this;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));


/***/ }),

/***/ "./resources/scripts/components/DataLayer/DataLayer.ts":
/*!*************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/DataLayer.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEBUG_MODE": () => (/* binding */ DEBUG_MODE),
/* harmony export */   "DataLayer": () => (/* binding */ DataLayer)
/* harmony export */ });
/* harmony import */ var _utils_Logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/Logger */ "./resources/scripts/utils/Logger.ts");
/* harmony import */ var _utils_Storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @utils/Storage */ "./resources/scripts/utils/Storage.ts");
/* harmony import */ var _utils_datalayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @utils/datalayer */ "./resources/scripts/utils/datalayer/dataLayerLogger.ts");
/* harmony import */ var _utils_datalayer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @utils/datalayer */ "./resources/scripts/utils/datalayer/toAbsoluteUrl.ts");
/* harmony import */ var _utils_sha256__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @utils/sha256 */ "./resources/scripts/utils/sha256.ts");
/* harmony import */ var _cartInterceptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./cartInterceptor */ "./resources/scripts/components/DataLayer/cartInterceptor.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }





// Set to false before going live
var DEBUG_MODE = true;
var CONSENT_STORAGE_KEY = "cookieSelections";
var DL_QUEUE = {
  KEY: "dl_pending_queue",
  TTL_MINUTES: 30,
  MAX_SIZE: 20
};
var PAGE_DATA_DEFAULTS = {
  pageType: "other",
  product: null,
  collection: null,
  searchQuery: null,
  customer: null
};
/**
 * Consent-aware theme dataLayer — collects page, user, and ecommerce events
 * and pushes them to `window.dataLayer` for GTM consumption.
 *
 * Initialisation is deferred until `CookieBanner` fires `edition:consent-default-set`,
 * guaranteeing Consent Mode v2 defaults are applied before any event is pushed.
 * Events that require analytics consent but arrive before it is granted are held
 * in `localStorage` (30-minute TTL, max 20 events) and flushed automatically when `edition:consent-updated` fires.
 *
 * Page-scoped data (product, collection, customer) is read from the
 * `#datalayer-data` JSON script tag rendered by `datalayer-data.liquid`.
 *
 * @example
 * ```ts
 * // app.ts
 * const dataLayer = new DataLayer();
 * dataLayer.init();
 * ```
 *
 * @example
 * ```ts
 * // Trigger a cart view from a cart drawer component
 * window.editionDataLayer?.trackCartView();
 * ```
 *
 * @see {@link https://developers.google.com/tag-platform/devguides/consent} Consent Mode v2
 */
var DataLayer = /*#__PURE__*/_createClass(function DataLayer() {
  var _this = this;
  _classCallCheck(this, DataLayer);
  /**
   * Registers the two window event listeners that drive the lifecycle.
   * Must be called once from `app.ts` — safe to call before `CookieBanner` connects.
   *
   * - `edition:consent-default-set` → runs full initialisation (once).
   * - `edition:consent-updated`     → flushes the session queue.
   */
  _defineProperty(this, "init", function () {
    window.addEventListener("edition:consent-default-set", function () {
      _this.initialize()["catch"](function (err) {
        return _utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("DataLayer init failed", err);
      });
    }, {
      once: true
    });
    window.addEventListener("edition:consent-updated", function () {
      _this.flushQueue();
    });
  });
  /** Runs the full initialisation sequence — pushes context, user, and page events then wires up interceptors. */
  _defineProperty(this, "initialize", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var pageData;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          window.dataLayer = window.dataLayer || [];
          pageData = _this.readPageData();
          _this.pushLocation();
          _this.pushContextData({
            pageType: pageData.pageType
          });
          _this.pushDeviceData();
          if (!pageData.customer) {
            _context.n = 1;
            break;
          }
          _context.n = 1;
          return _this.pushUserData({
            customer: pageData.customer
          });
        case 1:
          _context.n = 2;
          return _this.pushPageTypeEvent({
            pageData: pageData
          });
        case 2:
          (0,_cartInterceptor__WEBPACK_IMPORTED_MODULE_1__.initCartInterceptor)({
            onAddToCart: function onAddToCart(payload) {
              return _this.pushToDataLayer({
                payload: payload,
                consentRequirement: "analytics"
              });
            },
            onRemoveFromCart: function onRemoveFromCart(payload) {
              return _this.pushToDataLayer({
                payload: payload,
                consentRequirement: "analytics"
              });
            }
          });
          _this.bindFormListeners();
          window.editionDataLayer = {
            trackCartView: _this.trackCartView,
            trackAddToCart: _this.trackAddToCart,
            trackRemoveFromCart: _this.trackRemoveFromCart
          };
          if (DEBUG_MODE) {
            (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
              category: "init",
              label: "DataLayer initialized",
              payload: {
                pageType: pageData.pageType
              }
            });
          }
        case 3:
          return _context.a(2);
      }
    }, _callee);
  })));
  /** Parses the `#datalayer-data` JSON script tag injected by `datalayer-data.liquid`. Returns safe defaults on failure. */
  _defineProperty(this, "readPageData", function () {
    var el = document.getElementById("datalayer-data");
    if (!(el !== null && el !== void 0 && el.textContent)) {
      return PAGE_DATA_DEFAULTS;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (_unused) {
      _utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].warn("Failed to parse #datalayer-data JSON");
      return PAGE_DATA_DEFAULTS;
    }
  });
  /**
   * Pushes a payload to `window.dataLayer` if the required consent is granted,
   * otherwise holds it in `sessionStorage` for later flushing.
   */
  _defineProperty(this, "pushToDataLayer", function (_ref2) {
    var payload = _ref2.payload,
      consentRequirement = _ref2.consentRequirement;
    var isEvent = payload.event.startsWith("edition_");
    if (_this.checkConsent({
      requirement: consentRequirement
    })) {
      window.dataLayer.push(payload);
      if (DEBUG_MODE) {
        (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
          category: isEvent ? "event" : "context",
          label: payload.event,
          payload: payload
        });
      }
    } else {
      _this.queueEvent({
        payload: payload,
        consentRequirement: consentRequirement
      });
      if (DEBUG_MODE) {
        (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
          category: "config",
          label: "Queued (no consent): ".concat(payload.event),
          payload: payload
        });
      }
    }
  });
  /** Reads consent state from localStorage — same key written by `CookieBanner`. */
  _defineProperty(this, "checkConsent", function (_ref3) {
    var requirement = _ref3.requirement;
    if (requirement === "none") {
      return true;
    }
    var selections = _utils_Storage__WEBPACK_IMPORTED_MODULE_3__.local.get(CONSENT_STORAGE_KEY);
    if (!selections) {
      return false;
    }
    if (requirement === "analytics") {
      return selections.analytics;
    }
    if (requirement === "marketing") {
      return selections.marketing;
    }
    return false;
  });
  /** Appends an event to the queue, dropping the oldest if the cap is reached. Persists for 30 minutes across page loads. */
  _defineProperty(this, "queueEvent", function (event) {
    var queue = _this.getQueue();
    if (queue.length >= DL_QUEUE.MAX_SIZE) {
      queue.shift();
    }
    queue.push(event);
    _utils_Storage__WEBPACK_IMPORTED_MODULE_3__.local.set(DL_QUEUE.KEY, queue, DL_QUEUE.TTL_MINUTES);
  });
  /** Returns the current queue from localStorage, or an empty array if nothing is queued or TTL has expired. */
  _defineProperty(this, "getQueue", function () {
    var _local$get;
    return (_local$get = _utils_Storage__WEBPACK_IMPORTED_MODULE_3__.local.get(DL_QUEUE.KEY)) !== null && _local$get !== void 0 ? _local$get : [];
  });
  /**
   * Replays all queued events that now have consent, leaving the rest in place.
   * Called automatically on `edition:consent-updated`.
   */
  _defineProperty(this, "flushQueue", function () {
    var queue = _this.getQueue();
    if (!queue.length) {
      return;
    }
    var remaining = [];
    queue.forEach(function (_ref4) {
      var payload = _ref4.payload,
        consentRequirement = _ref4.consentRequirement;
      if (_this.checkConsent({
        requirement: consentRequirement
      })) {
        window.dataLayer.push(payload);
        if (DEBUG_MODE) {
          (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
            category: "event",
            label: "Flushed: ".concat(payload.event),
            payload: payload
          });
        }
      } else {
        remaining.push({
          payload: payload,
          consentRequirement: consentRequirement
        });
      }
    });
    _utils_Storage__WEBPACK_IMPORTED_MODULE_3__.local.set(DL_QUEUE.KEY, remaining, DL_QUEUE.TTL_MINUTES);
    var flushed = queue.length - remaining.length;
    if (flushed > 0 && DEBUG_MODE) {
      (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_2__.debugLog)({
        category: "init",
        label: "Flushed ".concat(flushed, " queued events"),
        payload: {
          remaining: remaining.length
        }
      });
    }
  });
  /** Pushes the current page URL breakdown and shop domain. No consent required. */
  _defineProperty(this, "pushLocation", function () {
    var _window$Shopify$shop, _window$Shopify;
    var _window$location = window.location,
      hash = _window$location.hash,
      host = _window$location.host,
      hostname = _window$location.hostname,
      href = _window$location.href,
      origin = _window$location.origin,
      pathname = _window$location.pathname,
      port = _window$location.port,
      protocol = _window$location.protocol,
      search = _window$location.search;
    _this.pushToDataLayer({
      payload: {
        event: "location",
        location: {
          hash: hash,
          host: host,
          hostname: hostname,
          href: href,
          origin: origin,
          pathname: pathname,
          port: port,
          protocol: protocol,
          search: search
        },
        shop: (_window$Shopify$shop = (_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.shop) !== null && _window$Shopify$shop !== void 0 ? _window$Shopify$shop : null
      },
      consentRequirement: "none"
    });
  });
  /** Pushes page type, title, and URL. No consent required. */
  _defineProperty(this, "pushContextData", function (_ref5) {
    var pageType = _ref5.pageType;
    _this.pushToDataLayer({
      payload: {
        event: "contextData",
        page: {
          type: pageType,
          title: document.title,
          url: window.location.href
        }
      },
      consentRequirement: "none"
    });
  });
  /** Pushes browser/device signals — language, screen size, user agent, cookie state. No consent required. */
  _defineProperty(this, "pushDeviceData", function () {
    _this.pushToDataLayer({
      payload: {
        event: "deviceData",
        encoding: document.characterSet,
        language: navigator.language,
        cookieEnabled: navigator.cookieEnabled,
        screen: "".concat(window.innerWidth, "x").concat(window.innerHeight),
        userAgent: navigator.userAgent
      },
      consentRequirement: "none"
    });
  });
  /** Hashes PII fields with SHA-256 before pushing — email, phone, first/last name. */
  _defineProperty(this, "pushUserData", /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref6) {
      var _customer$email, _customer$phone, _customer$first_name, _customer$first_name2, _customer$last_name;
      var customer, _yield$Promise$all, _yield$Promise$all2, sha256Email, sha256Phone, sha256FirstName, sha256LastName;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            customer = _ref6.customer;
            _context2.n = 1;
            return Promise.all([customer.email ? (0,_utils_sha256__WEBPACK_IMPORTED_MODULE_4__.sha256)(customer.email.toLowerCase().trim()) : null, customer.phone ? (0,_utils_sha256__WEBPACK_IMPORTED_MODULE_4__.sha256)(customer.phone.replace(/\D/g, "")) : null, customer.first_name ? (0,_utils_sha256__WEBPACK_IMPORTED_MODULE_4__.sha256)(customer.first_name.toLowerCase().trim()) : null, customer.last_name ? (0,_utils_sha256__WEBPACK_IMPORTED_MODULE_4__.sha256)(customer.last_name.toLowerCase().trim()) : null]);
          case 1:
            _yield$Promise$all = _context2.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
            sha256Email = _yield$Promise$all2[0];
            sha256Phone = _yield$Promise$all2[1];
            sha256FirstName = _yield$Promise$all2[2];
            sha256LastName = _yield$Promise$all2[3];
            _this.pushToDataLayer({
              payload: {
                event: "userData",
                customer: {
                  email: (_customer$email = customer.email) !== null && _customer$email !== void 0 ? _customer$email : null,
                  phone_number: (_customer$phone = customer.phone) !== null && _customer$phone !== void 0 ? _customer$phone : null,
                  sha256_email_address: sha256Email,
                  sha256_phone_number: sha256Phone,
                  address: ((_customer$first_name = customer.first_name) !== null && _customer$first_name !== void 0 ? _customer$first_name : customer.last_name) ? {
                    first_name: (_customer$first_name2 = customer.first_name) !== null && _customer$first_name2 !== void 0 ? _customer$first_name2 : null,
                    last_name: (_customer$last_name = customer.last_name) !== null && _customer$last_name !== void 0 ? _customer$last_name : null,
                    sha256_first_name: sha256FirstName,
                    sha256_last_name: sha256LastName
                  } : null
                }
              },
              consentRequirement: "analytics"
            });
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref7.apply(this, arguments);
    };
  }());
  /**
   * Dispatches the page-type-specific event based on `pageData.pageType`.
   * For `search`, reads `?q` from the URL rather than relying on Liquid output.
   */
  _defineProperty(this, "pushPageTypeEvent", /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref8) {
      var pageData, _URLSearchParams$get, query, exhaustiveCheck, _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            pageData = _ref8.pageData;
            console.log("DataLayer: pushPageTypeEvent", pageData);
            _t = pageData.pageType;
            _context3.n = _t === "product" ? 1 : _t === "collection" ? 2 : _t === "search" ? 3 : _t === "cart" ? 4 : _t === "other" ? 6 : 7;
            break;
          case 1:
            if (pageData.product) {
              _this.pushViewItem({
                product: pageData.product
              });
            }
            return _context3.a(3, 8);
          case 2:
            if (pageData.collection) {
              _this.pushCollectionView({
                collection: pageData.collection
              });
            }
            return _context3.a(3, 8);
          case 3:
            query = (_URLSearchParams$get = new URLSearchParams(window.location.search).get("q")) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : pageData.searchQuery;
            if (query) {
              _this.pushSearch({
                query: query
              });
            }
            return _context3.a(3, 8);
          case 4:
            _context3.n = 5;
            return _this.trackCartView();
          case 5:
            return _context3.a(3, 8);
          case 6:
            return _context3.a(3, 8);
          case 7:
            exhaustiveCheck = pageData.pageType;
            _utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].warn("Unhandled DataLayer page type", exhaustiveCheck);
          case 8:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x2) {
      return _ref9.apply(this, arguments);
    };
  }());
  /** Pushes `edition_view_item` using the URL-selected variant, falling back to the first variant. Requires analytics consent. */
  _defineProperty(this, "pushViewItem", function (_ref0) {
    var _ref1, _window$Shopify$curre, _window$Shopify2, _variant$featured_ima, _variant$featured_ima2, _variant$sku;
    var product = _ref0.product;
    var urlVariantId = new URLSearchParams(window.location.search).get("variant");
    var variant = (_ref1 = urlVariantId ? product.variants.find(function (v) {
      return String(v.id) === urlVariantId;
    }) : null) !== null && _ref1 !== void 0 ? _ref1 : product.variants[0];
    if (!variant) {
      return;
    }
    _this.pushToDataLayer({
      payload: {
        event: "edition_view_item",
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          currency: (_window$Shopify$curre = (_window$Shopify2 = window.Shopify) === null || _window$Shopify2 === void 0 || (_window$Shopify2 = _window$Shopify2.currency) === null || _window$Shopify2 === void 0 ? void 0 : _window$Shopify2.active) !== null && _window$Shopify$curre !== void 0 ? _window$Shopify$curre : "",
          value: variant.price / 100,
          items: [{
            item_name: product.title,
            item_id: String(product.id),
            item_brand: product.vendor,
            item_type: product.type,
            item_variant: String(variant.id),
            item_variant_name: variant.title,
            item_image: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.toAbsoluteUrl)((_variant$featured_ima = (_variant$featured_ima2 = variant.featured_image) === null || _variant$featured_ima2 === void 0 ? void 0 : _variant$featured_ima2.src) !== null && _variant$featured_ima !== void 0 ? _variant$featured_ima : product.featured_image),
            item_url: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.toAbsoluteUrl)("/products/".concat(product.handle)),
            price: variant.price / 100,
            sku: (_variant$sku = variant.sku) !== null && _variant$sku !== void 0 ? _variant$sku : null,
            quantity: 1
          }]
        }
      },
      consentRequirement: "analytics"
    });
  });
  /** Pushes `edition_collection_view` with all currently-rendered products (first 30 from Liquid). Requires analytics consent. */
  _defineProperty(this, "pushCollectionView", function (_ref10) {
    var _window$Shopify$curre2, _window$Shopify3;
    var collection = _ref10.collection;
    var title = collection.title,
      handle = collection.handle,
      products = collection.products;
    _this.pushToDataLayer({
      payload: {
        event: "edition_collection_view",
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          currency: (_window$Shopify$curre2 = (_window$Shopify3 = window.Shopify) === null || _window$Shopify3 === void 0 || (_window$Shopify3 = _window$Shopify3.currency) === null || _window$Shopify3 === void 0 ? void 0 : _window$Shopify3.active) !== null && _window$Shopify$curre2 !== void 0 ? _window$Shopify$curre2 : "",
          value: 1,
          item_list_name: title,
          item_list_id: handle,
          item_list_products_count: products.length,
          items: products.flatMap(function (p) {
            return p.variants.map(function (v) {
              var _v$featured_image$src, _v$featured_image, _v$sku;
              return {
                item_name: p.title,
                item_id: String(p.id),
                item_brand: p.vendor,
                item_type: p.type,
                item_variant: String(v.id),
                item_variant_name: v.title,
                item_image: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.toAbsoluteUrl)((_v$featured_image$src = (_v$featured_image = v.featured_image) === null || _v$featured_image === void 0 ? void 0 : _v$featured_image.src) !== null && _v$featured_image$src !== void 0 ? _v$featured_image$src : p.featured_image),
                item_url: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.toAbsoluteUrl)("/products/".concat(p.handle)),
                price: v.price / 100,
                sku: (_v$sku = v.sku) !== null && _v$sku !== void 0 ? _v$sku : null
              };
            });
          })
        }
      },
      consentRequirement: "analytics"
    });
  });
  /** Pushes `edition_search` with the query string only — no result products. Requires analytics consent. */
  _defineProperty(this, "pushSearch", function (_ref11) {
    var query = _ref11.query;
    _this.pushToDataLayer({
      payload: {
        event: "edition_search",
        search_term: query,
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href
        }
      },
      consentRequirement: "analytics"
    });
  });
  /** Fetches `/cart.json` and pushes `edition_cart_view`. Call this when a cart drawer opens. */
  _defineProperty(this, "trackCartView", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
    var response, cart, _t2;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.p = _context4.n) {
        case 0:
          _context4.p = 0;
          _context4.n = 1;
          return fetch("/cart.json");
        case 1:
          response = _context4.v;
          _context4.n = 2;
          return response.json();
        case 2:
          cart = _context4.v;
          _this.pushToDataLayer({
            payload: {
              event: "edition_cart_view",
              ecommerce: {
                timestamp: new Date().toISOString(),
                url: window.location.href,
                currency: cart.currency,
                value: cart.total_price / 100,
                items: cart.items.map(function (item) {
                  var _item$featured_image;
                  return {
                    item_name: item.product_title,
                    item_id: String(item.product_id),
                    item_brand: item.vendor,
                    item_type: item.product_type,
                    item_variant: String(item.variant_id),
                    item_variant_name: item.variant_title,
                    item_image: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.toAbsoluteUrl)((_item$featured_image = item.featured_image) === null || _item$featured_image === void 0 ? void 0 : _item$featured_image.url),
                    item_url: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_5__.toAbsoluteUrl)(item.url),
                    price: item.price / 100,
                    sku: item.sku,
                    quantity: item.quantity
                  };
                })
              }
            },
            consentRequirement: "analytics"
          });
          _context4.n = 4;
          break;
        case 3:
          _context4.p = 3;
          _t2 = _context4.v;
          _utils_Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("DataLayer: failed to fetch cart", _t2);
        case 4:
          return _context4.a(2);
      }
    }, _callee4, null, [[0, 3]]);
  })));
  /** Manually push an `edition_add_to_cart` event — use when a custom flow bypasses `/cart/add.js`. */
  _defineProperty(this, "trackAddToCart", function (payload) {
    _this.pushToDataLayer({
      payload: payload,
      consentRequirement: "analytics"
    });
  });
  /** Manually push an `edition_remove_from_cart` event — use when a custom flow bypasses `/cart/update.js`. */
  _defineProperty(this, "trackRemoveFromCart", function (payload) {
    _this.pushToDataLayer({
      payload: payload,
      consentRequirement: "analytics"
    });
  });
  /** Listens for contact form submits on `document` and distinguishes newsletter vs contact events by form fields. */
  _defineProperty(this, "bindFormListeners", function () {
    document.addEventListener("submit", function (event) {
      var _form$getAttribute;
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        return;
      }
      var action = (_form$getAttribute = form.getAttribute("action")) !== null && _form$getAttribute !== void 0 ? _form$getAttribute : "";
      if (!action.includes("/contact")) {
        return;
      }
      var elements = Array.from(form.elements).filter(function (el) {
        return el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement;
      });
      var getField = function getField(name) {
        var _elements$find$value, _elements$find;
        return (_elements$find$value = (_elements$find = elements.find(function (el) {
          return el.name === name;
        })) === null || _elements$find === void 0 ? void 0 : _elements$find.value) !== null && _elements$find$value !== void 0 ? _elements$find$value : null;
      };
      var isNewsletter = elements.some(function (el) {
        return el.name === "contact[tags]" && el instanceof HTMLInputElement && el.value === "newsletter";
      });
      if (isNewsletter) {
        _this.pushToDataLayer({
          payload: {
            event: "edition_newsletter_subscribe",
            timestamp: new Date().toISOString(),
            customer_email: getField("contact[email]")
          },
          consentRequirement: "analytics"
        });
      } else {
        _this.pushToDataLayer({
          payload: {
            event: "edition_contact_form_submit",
            timestamp: new Date().toISOString(),
            customer_name: getField("contact[Name]"),
            customer_email: getField("contact[email]"),
            customer_phone: getField("contact[Phone number]"),
            comment: getField("contact[Comment]")
          },
          consentRequirement: "analytics"
        });
      }
    });
  });
});

/***/ }),

/***/ "./resources/scripts/components/DataLayer/cartInterceptor.ts":
/*!*******************************************************************!*\
  !*** ./resources/scripts/components/DataLayer/cartInterceptor.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "initCartInterceptor": () => (/* binding */ initCartInterceptor)
/* harmony export */ });
/* harmony import */ var _utils_datalayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @utils/datalayer */ "./resources/scripts/utils/datalayer/toAbsoluteUrl.ts");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

var resolveUrl = function resolveUrl(input) {
  if (typeof input === "string") {
    return input;
  }
  if (input instanceof URL) {
    return input.pathname;
  }
  return input.url;
};
var activeCurrency = function activeCurrency() {
  var _window$Shopify$curre, _window$Shopify;
  return (_window$Shopify$curre = (_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 || (_window$Shopify = _window$Shopify.currency) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.active) !== null && _window$Shopify$curre !== void 0 ? _window$Shopify$curre : "";
};
/**
 * Reads the intended quantity from the request body — the response quantity is the cart total, not what was added.
 * `index` picks the entry of a JSON `items[]` body (e.g. a pre-order split over several batches).
 */
var parseRequestQuantity = function parseRequestQuantity(init) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var body = init === null || init === void 0 ? void 0 : init.body;
  if (!body) {
    return 1;
  }
  try {
    if (typeof body === "string") {
      var parsed = JSON.parse(body);
      if (Array.isArray(parsed.items)) {
        var _parsed$items$index;
        return Number((_parsed$items$index = parsed.items[index]) === null || _parsed$items$index === void 0 ? void 0 : _parsed$items$index.quantity) || 1;
      }
      return Number(parsed.quantity) || 1;
    }
    if (body instanceof URLSearchParams) {
      return Number(body.get("quantity")) || 1;
    }
    if (body instanceof FormData) {
      return Number(body.get("quantity")) || 1;
    }
  } catch (_unused) {
    // fall through
  }
  return 1;
};
var buildCartItem = function buildCartItem(item, quantity) {
  var _item$featured_image;
  return {
    item_name: item.product_title,
    item_id: String(item.product_id),
    item_brand: item.vendor,
    item_type: item.product_type,
    item_variant: String(item.variant_id),
    item_variant_name: item.variant_title,
    item_image: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.toAbsoluteUrl)((_item$featured_image = item.featured_image) === null || _item$featured_image === void 0 ? void 0 : _item$featured_image.url),
    item_url: (0,_utils_datalayer__WEBPACK_IMPORTED_MODULE_0__.toAbsoluteUrl)(item.url),
    price: item.price / 100,
    sku: item.sku,
    quantity: quantity
  };
};
var diffCart = function diffCart(_ref) {
  var snapshot = _ref.snapshot,
    newCart = _ref.newCart,
    onAddToCart = _ref.onAddToCart,
    onRemoveFromCart = _ref.onRemoveFromCart;
  var currency = activeCurrency();
  var snapshotMap = new Map(snapshot.items.map(function (item) {
    return [item.key, item];
  }));
  var newMap = new Map(newCart.items.map(function (item) {
    return [item.key, item];
  }));
  snapshotMap.forEach(function (oldItem, key) {
    var _newMap$get$quantity, _newMap$get;
    var newQty = (_newMap$get$quantity = (_newMap$get = newMap.get(key)) === null || _newMap$get === void 0 ? void 0 : _newMap$get.quantity) !== null && _newMap$get$quantity !== void 0 ? _newMap$get$quantity : 0;
    if (newQty < oldItem.quantity) {
      var qtyRemoved = oldItem.quantity - newQty;
      onRemoveFromCart({
        event: "edition_remove_from_cart",
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          currency: currency,
          value: oldItem.price / 100 * qtyRemoved,
          items: [buildCartItem(oldItem, qtyRemoved)]
        }
      });
    }
  });
  newMap.forEach(function (newItem, key) {
    var _snapshotMap$get$quan, _snapshotMap$get;
    var oldQty = (_snapshotMap$get$quan = (_snapshotMap$get = snapshotMap.get(key)) === null || _snapshotMap$get === void 0 ? void 0 : _snapshotMap$get.quantity) !== null && _snapshotMap$get$quan !== void 0 ? _snapshotMap$get$quan : 0;
    if (newItem.quantity > oldQty) {
      var qtyAdded = newItem.quantity - oldQty;
      onAddToCart({
        event: "edition_add_to_cart",
        ecommerce: {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          currency: currency,
          value: newItem.price / 100 * qtyAdded,
          items: [buildCartItem(newItem, qtyAdded)]
        }
      });
    }
  });
};
/** Patches window.fetch to intercept Shopify cart endpoints and emit add/remove events. */
var initCartInterceptor = function initCartInterceptor(_ref2) {
  var onAddToCart = _ref2.onAddToCart,
    onRemoveFromCart = _ref2.onRemoveFromCart;
  var originalFetch = window.fetch.bind(window);
  var fetchCart = function fetchCart() {
    return originalFetch("/cart.json").then(function (r) {
      return r.json();
    });
  };
  window.fetch = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(input, init) {
      var url, response, snapshot, _response, newCart;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            url = resolveUrl(input);
            if (!url.includes("/cart/add")) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return originalFetch(input, init);
          case 1:
            response = _context.v;
            response.clone().json().then(function (data) {
              // /cart/add.js → { items: [...] }   /cart/add → single item object
              var items = "items" in data ? data.items : [data];
              var currency = activeCurrency();
              items.forEach(function (item, index) {
                var _item$vendor, _item$featured_image$, _item$featured_image2, _item$sku;
                var addedQuantity = parseRequestQuantity(init, index);
                onAddToCart({
                  event: "edition_add_to_cart",
                  ecommerce: {
                    timestamp: new Date().toISOString(),
                    url: window.location.href,
                    currency: currency,
                    value: item.price / 100 * addedQuantity,
                    items: [{
                      item_name: item.product_title,
                      item_id: String(item.id),
                      item_brand: (_item$vendor = item.vendor) !== null && _item$vendor !== void 0 ? _item$vendor : null,
                      item_type: item.product_type,
                      item_variant: String(item.id),
                      item_variant_name: item.variant_title,
                      item_image: (_item$featured_image$ = (_item$featured_image2 = item.featured_image) === null || _item$featured_image2 === void 0 ? void 0 : _item$featured_image2.url) !== null && _item$featured_image$ !== void 0 ? _item$featured_image$ : null,
                      item_url: item.url,
                      price: item.price / 100,
                      sku: (_item$sku = item.sku) !== null && _item$sku !== void 0 ? _item$sku : null,
                      quantity: addedQuantity
                    }]
                  }
                });
              });
            })["catch"](function () {});
            return _context.a(2, response);
          case 2:
            if (!(url.includes("/cart/update") || url.includes("/cart/change"))) {
              _context.n = 6;
              break;
            }
            _context.n = 3;
            return fetchCart();
          case 3:
            snapshot = _context.v;
            _context.n = 4;
            return originalFetch(input, init);
          case 4:
            _response = _context.v;
            _context.n = 5;
            return fetchCart();
          case 5:
            newCart = _context.v;
            diffCart({
              snapshot: snapshot,
              newCart: newCart,
              onAddToCart: onAddToCart,
              onRemoveFromCart: onRemoveFromCart
            });
            return _context.a(2, _response);
          case 6:
            return _context.a(2, originalFetch(input, init));
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ "./resources/scripts/components/Preorder/PreorderAddToCart.ts":
/*!********************************************************************!*\
  !*** ./resources/scripts/components/Preorder/PreorderAddToCart.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Splits a pre-order add-to-cart across the ShopLondon app's batches.
 *
 * snippets/buy-buttons.liquid prints the variant's orderable batches (active batch first) as
 * `<script type="application/json" data-preorder-batches>`. The theme's <product-form> (assets/theme.js) calls
 * `window.shoplondonPreorder.prepareAdd(form, formData)` before posting to /cart/add.js: when it returns a body, that
 * body is posted as JSON instead of the form data.
 *
 * Every batch gets its own line with the properties `Forventet levering: Uge N` and the hidden `_batch: <sequence>`,
 * which the app uses to allocate the order to that batch. Units already in the cart for a batch are deducted first,
 * and the total is capped at what the batches can hold.
 *
 * A variant that sells its own stock first ('in_stock' in the app) lists that stock as the first entry with an empty
 * sequence: those units are added as a normal line without pre-order properties, and only the rest becomes
 * pre-order lines.
 */
var DELIVERY_PROPERTY = "Forventet levering";
var BATCH_PROPERTY = "_batch";
var readBatches = function readBatches(form) {
  var _form$querySelector;
  var script = (_form$querySelector = form.querySelector("script[data-preorder-batches]")) !== null && _form$querySelector !== void 0 ? _form$querySelector : form.id ? document.querySelector("buy-buttons[form=\"".concat(CSS.escape(form.id), "\"] script[data-preorder-batches]")) : null;
  if (!(script !== null && script !== void 0 && script.textContent)) {
    return [];
  }
  try {
    var batches = JSON.parse(script.textContent);
    return Array.isArray(batches) ? batches.filter(function (batch) {
      return batch.quantity > 0;
    }) : [];
  } catch (_unused) {
    return [];
  }
};
/** Units of `variantId` already in the cart, per batch sequence. */
var quantitiesInCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(variantId) {
    var _window$Shopify$route, _window$Shopify;
    var inCart, response, cart;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          inCart = new Map();
          _context.n = 1;
          return fetch("".concat((_window$Shopify$route = (_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 || (_window$Shopify = _window$Shopify.routes) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.root) !== null && _window$Shopify$route !== void 0 ? _window$Shopify$route : "/", "cart.js"));
        case 1:
          response = _context.v;
          if (response.ok) {
            _context.n = 2;
            break;
          }
          return _context.a(2, inCart);
        case 2:
          _context.n = 3;
          return response.json();
        case 3:
          cart = _context.v;
          // Lines without `_batch` count against the own-stock entry (sequence "").
          cart.items.forEach(function (line) {
            if (line.variant_id === variantId) {
              var _line$properties$BATC, _line$properties, _inCart$get;
              var batch = String((_line$properties$BATC = (_line$properties = line.properties) === null || _line$properties === void 0 ? void 0 : _line$properties[BATCH_PROPERTY]) !== null && _line$properties$BATC !== void 0 ? _line$properties$BATC : "");
              inCart.set(batch, ((_inCart$get = inCart.get(batch)) !== null && _inCart$get !== void 0 ? _inCart$get : 0) + line.quantity);
            }
          });
          return _context.a(2, inCart);
      }
    }, _callee);
  }));
  return function quantitiesInCart(_x) {
    return _ref.apply(this, arguments);
  };
}();
/** Line item properties from the form (e.g. custom fields), minus the ones we set per batch. */
var formProperties = function formProperties(formData) {
  var properties = {};
  formData.forEach(function (value, key) {
    var match = key.match(/^properties\[(.+)\]$/);
    if (match && typeof value === "string" && match[1] !== DELIVERY_PROPERTY && match[1] !== BATCH_PROPERTY) {
      properties[match[1]] = value;
    }
  });
  return properties;
};
var prepareAdd = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(form, formData) {
    var batches, variantId, inCart, properties, items, remaining, onlyOwnStock, body, sections, sectionsUrl;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          batches = readBatches(form);
          variantId = Number(formData.get("id"));
          if (!(batches.length === 0 || !variantId)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, null);
        case 1:
          _context2.n = 2;
          return quantitiesInCart(variantId);
        case 2:
          inCart = _context2.v;
          properties = formProperties(formData);
          items = [];
          remaining = Math.max(Number(formData.get("quantity")) || 1, 1);
          batches.forEach(function (batch) {
            var _inCart$get2;
            var free = batch.quantity - ((_inCart$get2 = inCart.get(String(batch.sequence))) !== null && _inCart$get2 !== void 0 ? _inCart$get2 : 0);
            var take = Math.min(free, remaining);
            if (take > 0) {
              var ownStock = String(batch.sequence) === "";
              items.push({
                id: variantId,
                quantity: take,
                properties: ownStock ? properties : _objectSpread(_objectSpread({}, properties), {}, _defineProperty(_defineProperty({}, DELIVERY_PROPERTY, "Uge ".concat(batch.week)), BATCH_PROPERTY, String(batch.sequence)))
              });
              remaining -= take;
            }
          });
          // Every batch is already in the cart: post the form as-is and let Shopify's inventory check report it.
          // A single own-stock line is a normal add — no need to rebuild it either.
          onlyOwnStock = items.length === 1 && !(BATCH_PROPERTY in items[0].properties);
          if (!(items.length === 0 || onlyOwnStock)) {
            _context2.n = 3;
            break;
          }
          return _context2.a(2, null);
        case 3:
          body = {
            items: items
          };
          sections = formData.get("sections");
          sectionsUrl = formData.get("sections_url");
          if (typeof sections === "string" && sections !== "") {
            body.sections = sections;
          }
          if (typeof sectionsUrl === "string" && sectionsUrl !== "") {
            body.sections_url = sectionsUrl;
          }
          return _context2.a(2, body);
      }
    }, _callee2);
  }));
  return function prepareAdd(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var initPreorderAddToCart = function initPreorderAddToCart() {
  window.shoplondonPreorder = {
    prepareAdd: prepareAdd
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (initPreorderAddToCart);

/***/ }),

/***/ "./resources/scripts/utils/Logger.ts":
/*!*******************************************!*\
  !*** ./resources/scripts/utils/Logger.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint-disable no-console */
/**
 * Structured Logger Utility
 * Logs structured objects with timestamps, levels, and metadata
 *
 * @example
 * import log from '@utils/Logger';
 *
 * log.info('User logged in', { userId: 123 });
 * log.success('Payment processed', { amount: 99.99 });
 * log.warn('Cart is empty');
 * log.error('API request failed', { endpoint: '/api/cart' });
 */
var styles = {
  INFO: "color: #3B82F6; font-weight: bold;",
  SUCCESS: "color: #10B981; font-weight: bold;",
  WARN: "color: #F59E0B; font-weight: bold;",
  ERROR: "color: #EF4444; font-weight: bold;"
};
var createLogEntry = function createLogEntry(level, message, additionalData) {
  var includeStack = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var timestamp = new Date().toISOString();
  // Handle different message types
  var logMessage;
  var logData = additionalData;
  if (typeof message === "string") {
    logMessage = message;
  } else if (_typeof(message) === "object" && message !== null) {
    logMessage = "Object logged";
    logData = message;
  } else {
    logMessage = String(message);
  }
  var entry = {
    timestamp: timestamp,
    level: level,
    message: logMessage
  };
  if (logData !== undefined) {
    entry.data = logData;
  }
  // Add stack trace for errors or when explicitly requested
  if (includeStack) {
    var _Error = new Error(),
      stack = _Error.stack;
    if (stack) {
      // Remove the first 3 lines (Error message and logger internals)
      entry.stack = stack.split("\n").slice(3).join("\n");
    }
  }
  // Add context information
  if (typeof window !== "undefined") {
    entry.context = {
      url: window.location.href,
      userAgent: navigator.userAgent,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };
  }
  return entry;
};
var logWithStyle = function logWithStyle(consoleMethod, level, entry) {
  console[consoleMethod]("%c[".concat(level, "]"), styles[level], entry);
};
var logger = {
  info: function info(message, data) {
    var entry = createLogEntry("INFO", message, data);
    logWithStyle("log", "INFO", entry);
  },
  success: function success(message, data) {
    var entry = createLogEntry("SUCCESS", message, data);
    logWithStyle("log", "SUCCESS", entry);
  },
  warn: function warn(message, data) {
    var entry = createLogEntry("WARN", message, data, true);
    logWithStyle("warn", "WARN", entry);
  },
  error: function error(message, data) {
    var entry = createLogEntry("ERROR", message, data, true);
    logWithStyle("error", "ERROR", entry);
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (logger);

/***/ }),

/***/ "./resources/scripts/utils/SpriiImageOptimizer.ts":
/*!********************************************************!*\
  !*** ./resources/scripts/utils/SpriiImageOptimizer.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/**
 * SpriiImageOptimizer — HACK.
 *
 * The Sprii live-shopping widget ships oversized images from two different sources:
 *
 *  1. Video-cover images straight from Firebase Storage at full resolution
 *     (multi-MB JPEGs, e.g. 2954x5712) dropped into ~305-406px slots.
 *  2. Live-event product images from Sprii's own CDN (`widget.cdn.sprii.io`) —
 *     already WebP, but shipped over-sized (e.g. 560x1080 into a ~305-351px slot)
 *     and at too high a quality.
 *
 * We don't control the app's code, so we rewrite the `src` of those images through
 * the free wsrv.nl image proxy, which fetches the original and returns a resized,
 * recompressed WebP.
 *
 * This is a band-aid. The real fix is Sprii serving properly sized thumbnails.
 * Remove this once they do.
 *
 * Trade-offs:
 * - Depends on the third-party proxy wsrv.nl. If it's down, these images fail to
 *   load. For a hardened setup, swap PROXY for a Cloudflare Worker you control.
 * - The source URLs are already public (Firebase carries its token in the query
 *   string); we forward them to the proxy as-is.
 */
var PROXY = "https://wsrv.nl/";
var PROXY_HOST = "wsrv.nl";
// One rule per oversized Sprii source. Order doesn't matter — hosts are disjoint.
var SOURCES = [
// Firebase video covers: crop to the ~1.34:1 (tall) cover-slot ratio. The covers are
// `object-cover`, so cropping here just removes pixels the browser would discard anyway.
{
  host: "firebasestorage.googleapis.com",
  fallbackWidth: 440,
  maxWidth: 1080,
  crop: true,
  ratio: 1.34,
  quality: 62
},
// Sprii CDN live-event product images: preserve aspect ratio, cap width + recompress.
{
  host: "widget.cdn.sprii.io",
  fallbackWidth: 450,
  maxWidth: 1080,
  quality: 58
}];
/** Returns the matching rule for a src, or undefined if it's already proxied or not a known source. */
var ruleFor = function ruleFor(src) {
  return src.includes(PROXY_HOST) ? undefined : SOURCES.find(function (rule) {
    return src.includes(rule.host);
  });
};
/** Combined `img[src*=...]` selector covering every known source host. */
var SELECTOR = SOURCES.map(function (rule) {
  return "img[src*=\"".concat(rule.host, "\"]");
}).join(", ");
// Cap DPR so the responsive width is driven mostly by the slot size — which is what differs
// between mobile and desktop — rather than ballooning files on 2-3x phones. 1.5 keeps the
// mobile result near the previous fixed 450px while letting larger desktop slots scale up.
var DPR_CAP = 1.5;
/** Rendered CSS width of the image (or its slot when the image itself isn't measurable), or 0. */
var renderedWidth = function renderedWidth(img) {
  var _img$parentElement;
  return img.getBoundingClientRect().width || ((_img$parentElement = img.parentElement) === null || _img$parentElement === void 0 ? void 0 : _img$parentElement.getBoundingClientRect().width) || 0;
};
/** Responsive target width: measured slot width × capped DPR, falling back to the rule width when unmeasurable. */
var targetWidthFor = function targetWidthFor(img, rule) {
  var css = renderedWidth(img);
  var dpr = Math.min(window.devicePixelRatio || 1, DPR_CAP);
  var target = css > 0 ? css * dpr : rule.fallbackWidth;
  return Math.min(Math.round(target), rule.maxWidth);
};
/** Builds the proxied, recompressed WebP URL at the given width, cropping only when the rule asks. */
var toProxiedSrc = function toProxiedSrc(originalSrc, rule, width) {
  var crop = rule.crop && rule.ratio ? "&h=".concat(Math.round(width * rule.ratio), "&fit=cover") : "";
  return "".concat(PROXY, "?url=").concat(encodeURIComponent(originalSrc), "&w=").concat(width).concat(crop, "&output=webp&q=").concat(rule.quality, "&we");
};
// Candidate widths offered to the browser via srcset. `&we` means anything above the source's
// real width just serves the source — harmless padding for the small Sprii CDN images, useful
// headroom for the full-res Firebase covers.
var CANDIDATE_WIDTHS = [300, 450, 600, 800, 1080];
/** Builds a proxied `srcset` across CANDIDATE_WIDTHS so the browser can pick the right one. */
var buildSrcset = function buildSrcset(originalSrc, rule) {
  return CANDIDATE_WIDTHS.filter(function (w) {
    return w <= rule.maxWidth;
  }).map(function (w) {
    return "".concat(toProxiedSrc(originalSrc, rule, w), " ").concat(w, "w");
  }).join(", ");
};
/** Rewrites a single image through the proxy if it matches a known un-proxied source. */
var optimize = function optimize(img) {
  var src = img.currentSrc || img.src;
  if (!src) {
    return;
  }
  var rule = ruleFor(src);
  if (!rule) {
    return;
  }
  // Replace the original srcset with a proxied one and let the browser pick the width from the
  // ACTUAL rendered slot via sizes="auto" (works because these images are loading="lazy").
  // No fragile JS measurement — correct on mobile and desktop alike. `src` is the single-width
  // fallback for the rare browser that ignores srcset/sizes.
  img.sizes = "auto";
  img.srcset = buildSrcset(src, rule);
  img.src = toProxiedSrc(src, rule, targetWidthFor(img, rule));
};
/** Scans a subtree and optimizes any matching images already present. */
var scan = function scan(root) {
  root.querySelectorAll(SELECTOR).forEach(optimize);
};
/**
 * Starts watching the DOM for Sprii's lazily-injected images and rewrites them.
 * Safe to call once from `app.ts`. The src rewrite re-triggers the observer, but
 * the `wsrv.nl` guard in {@link optimize} stops any loop.
 */
var initSpriiImageOptimizer = function initSpriiImageOptimizer() {
  scan(document);
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes" && mutation.target instanceof HTMLImageElement) {
        optimize(mutation.target);
        return;
      }
      mutation.addedNodes.forEach(function (node) {
        if (node instanceof HTMLImageElement) {
          optimize(node);
        } else if (node instanceof Element) {
          scan(node);
        }
      });
    });
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["src"]
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (initSpriiImageOptimizer);

/***/ }),

/***/ "./resources/scripts/utils/Storage.ts":
/*!********************************************!*\
  !*** ./resources/scripts/utils/Storage.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NamespacedStorage": () => (/* binding */ NamespacedStorage),
/* harmony export */   "StorageHelper": () => (/* binding */ StorageHelper),
/* harmony export */   "local": () => (/* binding */ local),
/* harmony export */   "session": () => (/* binding */ session)
/* harmony export */ });
/* harmony import */ var _Logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Logger */ "./resources/scripts/utils/Logger.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 * Type-safe LocalStorage and SessionStorage Utility
 * Handles JSON parsing, expiration, and error handling
 *
 * @example
 * import { local, session } from '@utils/Storage';
 *
 * // Basic usage LocalStorage
 * local.set('user', { id: 123, name: 'John' });
 * const user = local.get('user'); // Returns parsed object or null
 *
 * // With expiration (in minutes)
 * local.set('token', 'abc123', 60); // Expires in 60 minutes
 *
 * // Basic usage SessionStorage
 * session.set('sessionId', 'xyz789');
 * const sessionId = session.get('sessionId'); // Returns 'xyz789' or null
 *
 * // Advanced usage with namespaces
 * const cartStorage = local.namespace('cart');
 * cartStorage.set('items', [{ id: 1, qty: 2 }]);
 * const items = cartStorage.get('items'); // Returns array or null
 */

var StorageHelper = /*#__PURE__*/function () {
  function StorageHelper(type) {
    _classCallCheck(this, StorageHelper);
    _defineProperty(this, "storage", null);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "isAvailable", false);
    this.type = type;
    this.checkAvailability();
  }
  /**
   * Check if storage is available (handles private browsing, etc.)
   */
  return _createClass(StorageHelper, [{
    key: "checkAvailability",
    value: function checkAvailability() {
      try {
        var storage = window[this.type];
        var testKey = "__storage_test__";
        storage.setItem(testKey, "test");
        storage.removeItem(testKey);
        this.storage = storage;
        this.isAvailable = true;
      } catch (e) {
        this.isAvailable = false;
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].warn("".concat(this.type, " is not available"), {
          error: e
        });
      }
    }
    /**
     * Set an item in storage
     */
  }, {
    key: "set",
    value: function set(key, value, expiresInMinutes) {
      if (!this.isAvailable || !this.storage) return false;
      try {
        var item = {
          value: value
        };
        if (expiresInMinutes) {
          item.expires = Date.now() + expiresInMinutes * 60 * 1000;
        }
        this.storage.setItem(key, JSON.stringify(item));
        return true;
      } catch (e) {
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("Failed to set storage item", {
          key: key,
          error: e
        });
        return false;
      }
    }
    /**
     * Get an item from storage
     */
  }, {
    key: "get",
    value: function get(key) {
      if (!this.isAvailable || !this.storage) return null;
      try {
        var raw = this.storage.getItem(key);
        if (!raw) return null;
        var item = JSON.parse(raw);
        // Check expiration
        if (item.expires && Date.now() > item.expires) {
          this.remove(key);
          return null;
        }
        return item.value;
      } catch (e) {
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("Failed to get storage item", {
          key: key,
          error: e
        });
        return null;
      }
    }
    /**
     * Remove an item from storage
     */
  }, {
    key: "remove",
    value: function remove(key) {
      if (!this.isAvailable || !this.storage) return false;
      try {
        this.storage.removeItem(key);
        return true;
      } catch (e) {
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("Failed to remove storage item", {
          key: key,
          error: e
        });
        return false;
      }
    }
    /**
     * Clear all items from storage
     */
  }, {
    key: "clear",
    value: function clear() {
      if (!this.isAvailable || !this.storage) return false;
      try {
        this.storage.clear();
        return true;
      } catch (e) {
        _Logger__WEBPACK_IMPORTED_MODULE_0__["default"].error("Failed to clear storage", {
          error: e
        });
        return false;
      }
    }
    /**
     * Check if a key exists in storage
     */
  }, {
    key: "has",
    value: function has(key) {
      if (!this.isAvailable || !this.storage) return false;
      return this.storage.getItem(key) !== null;
    }
    /**
     * Get all keys in storage
     */
  }, {
    key: "keys",
    value: function keys() {
      if (!this.isAvailable || !this.storage) return [];
      var keys = [];
      for (var i = 0; i < this.storage.length; i += 1) {
        var key = this.storage.key(i);
        if (key) keys.push(key);
      }
      return keys;
    }
    /**
     * Get storage size in bytes (approximate)
     */
  }, {
    key: "size",
    value: function size() {
      if (!this.isAvailable || !this.storage) return 0;
      var total = 0;
      for (var i = 0; i < this.storage.length; i += 1) {
        var key = this.storage.key(i);
        if (key) {
          var value = this.storage.getItem(key);
          if (value) {
            total += key.length + value.length;
          }
        }
      }
      return total;
    }
    /**
     * Create a namespaced storage helper
     * Prefixes all keys with the namespace
     */
  }, {
    key: "namespace",
    value: function namespace(prefix) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      return new NamespacedStorage(this, prefix);
    }
    /**
     * Check if storage is available
     */
  }, {
    key: "available",
    get: function get() {
      return this.isAvailable;
    }
  }]);
}();
/**
 * Namespaced storage helper
 * Automatically prefixes all keys with a namespace
 */
var NamespacedStorage = /*#__PURE__*/function () {
  function NamespacedStorage(storage, prefix) {
    _classCallCheck(this, NamespacedStorage);
    _defineProperty(this, "storage", void 0);
    _defineProperty(this, "prefix", void 0);
    this.storage = storage;
    this.prefix = prefix;
  }
  return _createClass(NamespacedStorage, [{
    key: "getKey",
    value: function getKey(key) {
      return "".concat(this.prefix, ":").concat(key);
    }
  }, {
    key: "set",
    value: function set(key, value, expiresInMinutes) {
      return this.storage.set(this.getKey(key), value, expiresInMinutes);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.storage.get(this.getKey(key));
    }
  }, {
    key: "remove",
    value: function remove(key) {
      return this.storage.remove(this.getKey(key));
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.storage.has(this.getKey(key));
    }
    /**
     * Clear all items in this namespace
     */
  }, {
    key: "clear",
    value: function clear() {
      var _this = this;
      var keys = this.storage.keys().filter(function (key) {
        return key.startsWith("".concat(_this.prefix, ":"));
      });
      var success = true;
      keys.forEach(function (key) {
        if (!_this.storage.remove(key)) {
          success = false;
        }
      });
      return success;
    }
    /**
     * Get all keys in this namespace (without prefix)
     */
  }, {
    key: "keys",
    value: function keys() {
      var _this2 = this;
      var prefixLength = this.prefix.length + 1;
      return this.storage.keys().filter(function (key) {
        return key.startsWith("".concat(_this2.prefix, ":"));
      }).map(function (key) {
        return key.substring(prefixLength);
      });
    }
  }]);
}(); // Export singleton instances
var local = new StorageHelper("localStorage");
var session = new StorageHelper("sessionStorage");
// Export classes for advanced usage


/***/ }),

/***/ "./resources/scripts/utils/ThemeScripts.ts":
/*!*************************************************!*\
  !*** ./resources/scripts/utils/ThemeScripts.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ThemeScripts": () => (/* binding */ ThemeScripts)
/* harmony export */ });
/* harmony import */ var _Storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Storage */ "./resources/scripts/utils/Storage.ts");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

var CONSENT_STORAGE_KEY = "cookieSelections";
var isConsentGranted = function isConsentGranted() {
  var selections = _Storage__WEBPACK_IMPORTED_MODULE_0__.local.get(CONSENT_STORAGE_KEY);
  return (selections === null || selections === void 0 ? void 0 : selections.analytics) === true;
};
var idleInject = function idleInject(inject) {
  if ("requestIdleCallback" in window) {
    requestIdleCallback(inject);
  } else {
    setTimeout(inject, 0);
  }
};
/**
 * First-interaction events used to lazy-load non-critical scripts. These cover
 * mouse, touch, keyboard, and scroll-intent without overlapping (`pointerdown`
 * covers mouse + touch + pen; `touchstart` is kept for older iOS Safari).
 *
 * Note we intentionally do NOT listen to `scroll`. Every real user scroll is
 * preceded by an input event we already capture (`wheel`, `touchstart`,
 * `keydown`, or `pointerdown`), whereas a bare `scroll` with no preceding input
 * only comes from programmatic scrolling — e.g. Lighthouse's full-page-screenshot
 * gatherer — which we must not treat as user intent.
 */
var INTERACTION_EVENTS = ["pointerdown", "touchstart", "keydown", "wheel", "mousemove"];
/** Fallback (ms) after which scripts load even without interaction, so bots/bouncers are still tracked. */
var INTERACTION_FALLBACK_MS = 10000;
/**
 * Runs `callback` once on the first genuine user interaction, or after
 * `INTERACTION_FALLBACK_MS` — whichever comes first. Listeners are passive
 * (never block scrolling) and are all removed after the first trigger.
 */
var onFirstInteraction = function onFirstInteraction(callback) {
  var fired = false;
  var timer;
  var _trigger = function trigger() {
    if (fired) return;
    fired = true;
    if (timer !== undefined) clearTimeout(timer);
    INTERACTION_EVENTS.forEach(function (event) {
      return window.removeEventListener(event, _trigger);
    });
    callback();
  };
  INTERACTION_EVENTS.forEach(function (event) {
    return window.addEventListener(event, _trigger, {
      once: true,
      passive: true
    });
  });
  timer = setTimeout(_trigger, INTERACTION_FALLBACK_MS);
};
/** Defers `inject` to the first user interaction (or a fallback timeout), then to browser idle time. */
var interactionInject = function interactionInject(inject) {
  return onFirstInteraction(function () {
    return idleInject(inject);
  });
};
var buildGtmSrc = function buildGtmSrc(_ref) {
  var containerId = _ref.containerId,
    serverUrl = _ref.serverUrl,
    scriptName = _ref.scriptName;
  if (serverUrl && scriptName) {
    var encodedId = btoa("id=".concat(containerId)).replace(/=+$/, "");
    return "".concat(serverUrl, "/").concat(scriptName, "?P=").concat(encodedId, "&page=1");
  }
  return "https://www.googletagmanager.com/gtm.js?id=".concat(containerId);
};
// ─── Class ────────────────────────────────────────────────────────────────────
/**
 * Third-party script loader with consent-aware loading strategies.
 * GTM is a first-class citizen — pass `id: 'gtm'` and `gtmConfig` and everything
 * else (URL building, `gtm.start` push, noscript fallback) is handled internally.
 *
 * `on-consent-granted` defers injection to `requestIdleCallback` once consent is granted,
 * so opt-in tags never block the critical rendering path. `on-default-consent-set` injects
 * straight away — GTM is treated as critical, not deferrable.
 *
 * @example GTM — client-side
 * ```ts
 * scripts.load({
 *   id: 'gtm',
 *   strategy: 'on-default-consent-set',
 *   gtmConfig: { containerId: 'GTM-XXXXXX' },
 * });
 * ```
 *
 * @example GTM — server-side via stape
 * ```ts
 * scripts.load({
 *   id: 'gtm',
 *   strategy: 'on-default-consent-set',
 *   gtmConfig: { containerId: 'GTM-XXXXXX', serverUrl: 'https://xyz.stape.net', scriptName: 'loader.js' },
 * });
 * ```
 *
 * @example Klaviyo onsite — Loads idlely to avoid blocking
 * ```ts
 * scripts.load({
 *   id: 'klaviyo',
 *   strategy: 'idle',
 *   src: 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=XXXXXX',
 * });
 * ```
 *
 * @example Non-critical widget deferred to browser idle time
 * ```ts
 * scripts.load({
 *   id: 'my-widget',
 *   strategy: 'idle',
 *   src: 'https://cdn.example.com/widget.js',
 * });
 * ```
 */
var ThemeScripts = /*#__PURE__*/_createClass(function ThemeScripts() {
  var _this = this;
  _classCallCheck(this, ThemeScripts);
  /** Loads a script according to its strategy. TypeScript narrows to `GtmScriptConfig` when `id: 'gtm'`. */
  _defineProperty(this, "load", function (config) {
    if (config.id === "gtm") {
      _this.loadGtm(config);
      return;
    }
    var id = config.id,
      strategy = config.strategy,
      src = config.src,
      inline = config.inline,
      _config$async = config.async,
      isAsync = _config$async === void 0 ? true : _config$async,
      _config$defer = config.defer,
      defer = _config$defer === void 0 ? false : _config$defer,
      _config$attributes = config.attributes,
      attributes = _config$attributes === void 0 ? {} : _config$attributes,
      onLoad = config.onLoad,
      onError = config.onError;
    _this.applyStrategy({
      strategy: strategy,
      inject: function inject() {
        return _this.inject({
          id: id,
          src: src,
          inline: inline,
          isAsync: isAsync,
          defer: defer,
          attributes: attributes,
          onLoad: onLoad,
          onError: onError
        });
      }
    });
  });
  /** Handles GTM-specific setup: dataLayer push, URL building, noscript fallback. */
  _defineProperty(this, "loadGtm", function (config) {
    var containerId = config.gtmConfig.containerId;
    _this.applyStrategy({
      strategy: config.strategy,
      inject: function inject() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js"
        });
        _this.inject({
          id: "gtm",
          src: buildGtmSrc(config.gtmConfig),
          isAsync: true,
          defer: false,
          attributes: {
            "data-gtm": containerId
          },
          onLoad: config.onLoad,
          onError: config.onError
        });
        if (!document.querySelector("noscript[data-gtm=\"".concat(containerId, "\"]"))) {
          var noscript = document.createElement("noscript");
          noscript.dataset.gtm = containerId;
          var iframe = document.createElement("iframe");
          iframe.src = "https://www.googletagmanager.com/ns.html?id=".concat(containerId);
          iframe.height = "0";
          iframe.width = "0";
          iframe.style.cssText = "display:none;visibility:hidden";
          noscript.appendChild(iframe);
          document.body.insertAdjacentElement("afterbegin", noscript);
        }
      }
    });
  });
  _defineProperty(this, "applyStrategy", function (_ref2) {
    var strategy = _ref2.strategy,
      inject = _ref2.inject;
    switch (strategy) {
      case "immediate":
        {
          inject();
          break;
        }
      case "on-default-consent-set":
        {
          window.addEventListener("edition:consent-default-set", inject, {
            once: true
          });
          break;
        }
      case "on-consent-granted":
        {
          window.addEventListener("edition:consent-default-set", function () {
            if (isConsentGranted()) {
              interactionInject(inject);
              return;
            }
            var _waitForConsent = function waitForConsent() {
              if (!isConsentGranted()) return;
              interactionInject(inject);
              window.removeEventListener("edition:consent-updated", _waitForConsent);
            };
            window.addEventListener("edition:consent-updated", _waitForConsent);
          }, {
            once: true
          });
          break;
        }
      case "idle":
        {
          idleInject(inject);
          break;
        }
      default:
        {
          var exhaustiveCheck = strategy;
          // eslint-disable-next-line no-console
          console.warn("[ThemeScripts] Unknown strategy:", exhaustiveCheck);
        }
    }
  });
  _defineProperty(this, "inject", function (_ref3) {
    var id = _ref3.id,
      src = _ref3.src,
      inline = _ref3.inline,
      isAsync = _ref3.isAsync,
      defer = _ref3.defer,
      attributes = _ref3.attributes,
      onLoad = _ref3.onLoad,
      onError = _ref3.onError;
    if (document.querySelector("script[data-script-id=\"".concat(id, "\"]"))) {
      return;
    }
    if (inline) {
      inline();
    }
    if (!src) {
      return;
    }
    var script = document.createElement("script");
    script.async = isAsync;
    script.defer = defer;
    script.src = src;
    script.dataset.scriptId = id;
    Object.entries(attributes).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        value = _ref5[1];
      script.setAttribute(key, value);
    });
    if (onLoad) {
      script.addEventListener("load", onLoad);
    }
    if (onError) {
      script.addEventListener("error", onError);
    }
    document.head.appendChild(script);
  });
});

/***/ }),

/***/ "./resources/scripts/utils/datalayer/dataLayerLogger.ts":
/*!**************************************************************!*\
  !*** ./resources/scripts/utils/datalayer/dataLayerLogger.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "debugLog": () => (/* binding */ debugLog)
/* harmony export */ });
var LOG_STYLES = {
  header: "background:#4f46e5;color:#fff;padding:2px 8px;border-radius:3px;font-weight:bold",
  event: "background:#10b981;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  context: "background:#0ea5e9;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  consent: "background:#8b5cf6;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  init: "background:#f59e0b;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  config: "background:#6b7280;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;margin-left:4px",
  label: "color:inherit;font-weight:bold;margin-left:4px",
  muted: "color:#6b7280;font-style:italic;margin-left:4px"
};
var CATEGORY_LABELS = {
  event: "Event",
  context: "Context",
  consent: "Consent",
  init: "Init",
  config: "Config"
};
var debugLog = function debugLog(_ref) {
  var category = _ref.category,
    label = _ref.label,
    payload = _ref.payload;
  var timestamp = new Date().toISOString();
  var displayTime = timestamp.split("T")[1].replace("Z", "");
  var categoryStyle = LOG_STYLES[category];
  console.groupCollapsed("%cEdition DataLayer%c%s%c%s%c%s", LOG_STYLES.header, categoryStyle, " ".concat(CATEGORY_LABELS[category]), LOG_STYLES.label, " ".concat(label), LOG_STYLES.muted, " ".concat(displayTime));
  if (payload !== undefined) console.log(payload);
  console.groupEnd();
};

/***/ }),

/***/ "./resources/scripts/utils/datalayer/toAbsoluteUrl.ts":
/*!************************************************************!*\
  !*** ./resources/scripts/utils/datalayer/toAbsoluteUrl.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "toAbsoluteUrl": () => (/* binding */ toAbsoluteUrl)
/* harmony export */ });
/** Resolves protocol-relative (`//`) and root-relative (`/`) URLs to fully qualified `https://` URLs. */
var toAbsoluteUrl = function toAbsoluteUrl(url) {
  if (!url) {
    return null;
  }
  if (url.startsWith("//")) {
    return "https:".concat(url);
  }
  if (url.startsWith("/")) {
    return "".concat(window.location.origin).concat(url);
  }
  return url;
};

/***/ }),

/***/ "./resources/scripts/utils/sha256.ts":
/*!*******************************************!*\
  !*** ./resources/scripts/utils/sha256.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sha256": () => (/* binding */ sha256)
/* harmony export */ });
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/** Hashes a string with SHA-256 using the Web Crypto API. Returns null if the value is empty or hashing fails. */
var sha256 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
    var encoded, hashBuffer, hashArray, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (value) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          _context.p = 1;
          encoded = new TextEncoder().encode(value);
          _context.n = 2;
          return crypto.subtle.digest("SHA-256", encoded);
        case 2:
          hashBuffer = _context.v;
          hashArray = Array.from(new Uint8Array(hashBuffer));
          return _context.a(2, hashArray.map(function (b) {
            return b.toString(16).padStart(2, "0");
          }).join(""));
        case 3:
          _context.p = 3;
          _t = _context.v;
          return _context.a(2, null);
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function sha256(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./resources/styles/app.css":
/*!**********************************!*\
  !*** ./resources/styles/app.css ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/shopify-theme/assets/edition": 0,
/******/ 			"shopify-theme/assets/edition": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshuplondon.com"] = self["webpackChunkshuplondon.com"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["shopify-theme/assets/edition"], () => (__webpack_require__("./resources/styles/app.css")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;